// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_UpdaterelacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for updateRelacao() /localidades/updateRelacao
 *
 * Updates a location-franchise relationship.
 * Returns a boolean success flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_UpdaterelacaoResponseDados = boolean;

export type Localidades_UpdaterelacaoResponse = ApiResponse<Localidades_UpdaterelacaoResponseDados>;

registerResponseContract('Localidades_UpdaterelacaoResponse', {})
